import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    email: "asdadqdwe123@gmail.com",
    invitationId: "6272b9a9-bcac-402d-bc38-25c6251900f6",
    organizationName: "MSPY",
  },
};

export const meSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setMeInvitations: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setMeInvitations } = meSlice.actions;

export default meSlice.reducer;
